var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8156 35.889V10.5447L30.9974 0H0V53.3402H26.4727C28.7013 57.2867 33.226 60 38.4935 60C45.9221 60 52 54.4502 52 47.667C52 42.1788 48.1506 37.554 42.8156 35.889ZM7.49611 17.3895H38.426V18.9928H7.49611V17.3895V17.3895ZM7.49611 21.5827H30.4571V23.186H7.49611V21.5827ZM7.49611 25.8376H28.3636V27.4409H7.49611V25.8376ZM7.49611 30.0308H31.6727V31.6341H7.49611V30.0308V30.0308ZM6.01039 35.889H4.32207V34.3474H6.01039V35.889ZM6.01039 31.6341H4.32207V30.0925H6.01039V31.6341ZM6.01039 27.3792H4.32207V25.8376H6.01039V27.3792ZM6.01039 23.186H4.32207V21.6444H6.01039V23.186ZM6.01039 18.9311H4.32207V17.3895H6.01039V18.9311ZM7.49611 34.2857H32.2805V35.889H7.49611V34.2857V34.2857ZM38.426 58.0884C32.0779 58.0884 26.9455 53.4018 26.9455 47.6053C26.9455 44.8921 28.0935 42.3638 29.9844 40.5139L45.4494 55.9301C43.4909 57.2867 41.0597 58.0884 38.426 58.0884ZM46.9351 54.6968L31.4701 39.2806C33.4286 37.9239 35.7922 37.1223 38.426 37.1223C44.774 37.1223 49.9065 41.8088 49.9065 47.6053C49.974 50.3186 48.826 52.8469 46.9351 54.6968Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledFileIcon);
export default __webpack_public_path__ + "static/media/disabledFileIcon.52baad39e04661e2dbb8693a111a4892.svg";
export { ForwardRef as ReactComponent };